export const LANGUAGE_MULTI_SELECT_TRANSLATION_EN = {
  de: 'German',
  en: 'English',
  fr: 'French',
  el: 'EL',
  it: 'Italian',
  pl: 'Polish',
  pt: 'Portuguese',
  ru: 'Russian',
  es: 'Spanish',
  tr: 'Turkish',
  ar: 'Arabian',
  bg: 'Bulgarian',
  zh: 'ZH',
  da: 'DA',
  et: 'ET',
  fi: 'Finnish',
  ga: 'GA',
  hr: 'HR',
  ku: 'KU',
  lv: 'LV',
  lt: 'Lithuanian',
  mt: 'MT',
  nl: 'Dutch',
  no: 'NO',
  ro: 'Romanian',
  sr: 'SR',
  sv: 'SV',
  sk: 'SK',
  sl: 'Slovenian',
  cs: 'CS',
  hu: 'HU',
  vi: 'VI',
} as const;
